<div>
  <h4 class="form-section">
    <i class="ft-cpu"></i> {{ 'companyBanks.title' | translate: company }} </h4>
</div>
<div class="card">
  <div class="card-header">
    <button [hidden]="!sectionPermission.CanAdd || !company.IsSuccessfullyOnboarded"
            class="btn btn-raised btn-primary float-right" type="button" (click)="openModal()">
      <i
        class="ft-plus-circle"></i> {{ hasDesktopView ? ('companyBanks.addNewButtonText' | translate) : ('buttons.newText' | translate) }}
    </button>
  </div>
  <div class="card-body">
    <div [class]="hasDesktopView ? 'px-3' : 'px-0'">
      <table
        [class]="hasDesktopView ? 'table table-sortable table-responsive-md' : 'table-borderless table-sortable table-responsive-sm table'">
        <thead>
        <tr>
          <th *ngFor="let field of fieldCollection"
              [ngClass]="getTableHeaderClass(field.canSort, pageConfiguration.IsAscending, field.displayClass)"
              (click)="sort(field.canSort, field.name)">
            {{ field.displayName | translate }}
          </th>
        </tr>
        </thead>
        <tbody>
        <tr
          *ngFor="let currentObject of collection | paginate: { id: 'server', itemsPerPage: pageConfiguration.PageSize, currentPage: pageConfiguration.PageNumber, totalItems: pageConfiguration.TotalRecords }">
          <td class="d-none d-sm-table-cell">{{ currentObject.CompanyBankId }}</td>
          <td class="col-md-5 col-6">{{ currentObject.BankName }}</td>
          <td *ngIf="showConsentLinkExpirationDate"
              class="d-none d-sm-table-cell">{{ currentObject.ConsentLinkExpirationDate | date:'d-M-y' }}
          </td>
          <td class="d-none d-sm-table-cell">{{ currentObject.ConsentExpirationDate | date:'d-M-y' }}</td>
          <td>
            <a *ngIf="sectionPermission.CanEdit || !company.IsSuccessfullyOnboarded" class="success" data-original-title=""
               title="{{'companyBanks.editCompanyBankTitle' | translate }}" (click)="openEditModal(currentObject)">
              <i class="ft-edit-2 font-medium-3"></i>
            </a>
            <a *ngIf="!consentUrlInvalid(currentObject)" class="warning" data-original-title=""
               title="{{'companyBanks.openConsentUrlTitle' | translate: currentObject}}"
               (click)="openConsentUrl(currentObject)">
              <i class="ft-link font-medium-3 mr-1"></i>
            </a>
            <i [ngClass]="currentObject.ConsentStatus.IconClass" title="{{currentObject.ConsentStatus.Hint}}"></i>
          </td>
        </tr>
        </tbody>
      </table>
      <pagination-controls *ngIf="pageConfiguration.TotalRecords > pageConfiguration.PageSize"
                           (pageChange)="pageChanged($event)" id="server"
                           previousLabel="{{'pagination.previousLabel' | translate}}"
                           nextLabel="{{'pagination.nextLabel' | translate}}">
      </pagination-controls>
    </div>
  </div>
</div>
